<p-toast key="globalToast" position="bottom-right"></p-toast>
<app-info-modal #informationModal [title]="'Session Expired'" (onClose)="onCloseExpirationModal()"
  [message]="'Your session has expired. Please login again.'" [buttonText]="'OK'" type="info">
</app-info-modal>
<ng-container>
  <router-outlet></router-outlet>
</ng-container>

